import styled, { css } from "styled-components";
import { Image } from "@commonlibs";

export enum SizeBanner {
    sm = "small",
    md = "medium",
}

type BannerRootProps = {
    size?: SizeBanner;
};

export const BannerRoot = styled(Image)<BannerRootProps>(
    ({ theme, size = "small" }) => css`
        width: ${size === "medium" ? "100%" : "19rem"};
        --min-width: min(21.25rem, calc(100vw - 2 * var(--base-page-padding)));
        min-width: --min-width;
        height: ${size === "medium" ? "calc(var(--min-width) * 0.5)" : "6.375rem"}; // La altura es el 50% del ancho de la imagen
        border-radius: ${theme.borderRadius};
        cursor: pointer;
    `,
);
